<template>
    <div v-cloak>
        <div class="row">

            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'integraciones'}">{{$t("integraciones")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t("cheerfy")}}</li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>{{$t("negocio")}}</label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idBusiness"
                                           filterable
                                           :placeholder="$t('seleccionaNegocio')"
                                           @change="cambioNegocio()">
                                    <el-option v-for="business in listBusinesses"
                                               class="select-primary"
                                               :value="business.id"
                                               :label="business.establishmentName"
                                               :key="business.establishmentName">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label>{{$t("TPV")}}</label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idTpv"
                                           filterable
                                           :placeholder="$t('seleccionaTpv')"
                                           @change="cambioTpv()">
                                    <el-option v-for="tpv in listTpv"
                                               class="select-primary"
                                               :value="tpv.id"
                                               :label="tpv.nameShow"
                                               :key="tpv.nameShow">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <template v-if="restriccionCheerfy">
                <div class="col-md-12" v-if="respuesta">
                    <div class="card">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="form-group">
                                    <button @click="openModal()" class="btn btn-primary"><i
                                            class="fa fa-plus-square"></i>
                                        {{$t("nuevaPromocion")}}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="table-responsive" v-if="listPromociones.length>0 && respuesta">
                            <table class="table table-bordered table-striped">
                                <thead class="thead-dark">
                                <tr>
                                    <th>{{$t("codigo")}}</th>
                                    <th>{{$t("descuento")}}</th>
                                    <th>{{$t("fechaCreacion")}}</th>
                                    <th>{{$t("activo")}}</th>
                                    <th width="10%">{{$t("acciones")}}</th>
                                </tr>
                                </thead>

                                <tbody>
                                <tr v-for="promocion in listPromociones" :key="promocion.id">
                                    <td>
                                        <div>{{promocion.codigo}}</div>
                                    </td>
                                    <td>
                                        <div>{{promocion.tipoDescuento == 1 ? Math.round(promocion.descuento) : promocion.descuento}} {{promocion.tipoDescuento == 1 ? '%' : '€'}}</div>
                                    </td>
                                    <td>
                                        <div> {{ promocion.dateInicio | parseDateMin }}</div>
                                    </td>
                                    <td>
                                        <div class="btn btn-danger btn-link btn-xs" v-tooltip.top-center="$t('tolTipDisponiblePromocion')">
                                            <el-checkbox
                                                @change="changeActivo(promocion.id, promocion.active)"
                                                v-model="promocion.active"
                                            >
                                                <strong>
                                                    {{
                                                        promocion.active
                                                        ? $t("activo")
                                                        : $t("inactivo")
                                                    }}
                                                </strong>
                                            </el-checkbox>
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                            <a @click="getPromocion(promocion.id)" class="btn btn-danger btn-link btn-xs">
                                                <i v-tooltip.top-center="$i18n.t('editar')" class="fas fa-pencil-alt"
                                                style="color: orange"></i>
                                            </a>
                                            <a @click="modalBorrarPromocion(promocion.id)"
                                            class="btn btn-danger btn-link btn-xs">
                                                <i v-tooltip.top-center="$i18n.t('borrarPromocion')"
                                                class="fas fa-trash-alt text-danger"></i>
                                            </a>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-else class="alert alert-danger" role="alert">
                            {{$t("noHayPromocionesEnEsteTpv")}}
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="col-md-12">
                    <div class=" alert alert-primary" align="center">
                        <h3>
                            <i class="fas fa-exclamation-circle"></i>
                            {{ $t("esteNegocioNoTieneAccesoAEsteModulo") }}.
                        </h3>

                        <span>
                            {{ $t("paraMasInformacionContacteConSu") }}
                            <strong>{{ $t("distribuidor") }}</strong>.
                        </span>
                    </div>
                </div>
            </template>
        </div>

        <modal name="modal-nueva-promocion" :adaptive=true :scrollable=true height="auto" :clickToClose=false>
            <div>
                <div class="modal-header">
                    <h4 style="margin: 0px">{{$t("promociones")}}</h4>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <label for="codigo">{{$t("codigoPromocion")}}</label>
                        <input type="text" class="form-control"
                               v-model="codigo"
                               id="codigo">
                    </div>

                    <div class="form-group">
                        <label for="codigo">{{$t("descuento")}}</label>
                        <div class="row">
                            <div class="col-md-8">
                                <vue-numeric v-if="tipoDescuento==0" currency="€" inputmode="decimal" type="text" id="tarifa1" class="form-control"
                                    currency-symbol-position="suffix" :precision="2" v-model="cantidadDescuento"
                                    @keydown.native="$methods.evitarComasDecimales">
                                </vue-numeric>
                                <vue-numeric v-else currency="%" inputmode="numeric" type="text" id="tarifa1" class="form-control"
                                    currency-symbol-position="suffix" :precision="0" v-model="cantidadDescuento"
                                    @keydown.native="$methods.evitarComasDecimales">
                                </vue-numeric>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <el-select 
                                        class="select-default"
                                        size="large"
                                        v-model="tipoDescuento"
                                        filterable
                                        :placeholder="$t('seleccioneUnTipo')"
                                        @change="cambioTipoDescuento()"
                                    >
                                    <el-option              
                                        v-for="(descuento, index) in listTipoDescuento"
                                        class="select-primary"
                                        :value="descuento.code"
                                        :label="descuento.name"
                                        :key="index">

                                    </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="codigo">{{$t("estado")}}</label><br>
                        <div class="btn btn-danger btn-link btn-xs" v-tooltip.top-center="$t('tolTipDisponiblePromocion')">
                            <el-checkbox
                                v-model="active"
                            >
                                <strong>
                                    {{
                                        active
                                        ? $t("activo")
                                        : $t("inactivo")
                                    }}
                                </strong>
                            </el-checkbox>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div align="right" class="col-12">

                        <button class="btn btn-danger" @click="closeModal()"><i class="fa fa-window-close"></i>
                            {{$t("cancelar")}}
                        </button>

                        <button class="btn btn-primary" @click="savePromocion()"><i class="fa fa-check-square"></i>
                            {{$t("guardar")}}
                        </button>

                    </div>
                </div>
            </div>
        </modal>

    </div>
</template>
<script>
    import {DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button, Checkbox, CheckboxGroup} from 'element-ui'
    import swal from 'sweetalert2'

    export default {
        created() {
            this.$store.dispatch("setNameRoute", this.$i18n.t("cheerfy"));
            this.getBusiness();
            this.getRestriccionCheerfy();

            if (this.$store.getters.idBusiness) {
                this.idBusiness = this.$store.getters.idBusiness;
            }
            if (this.$store.getters.idTpv) {
                this.idTpv = this.$store.getters.idTpv;
            }
        },
        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup,
            [Button.name]: Button,
            [Option.name]: Option
        },
        data() {
            return {
                listBusinesses: [],
                listTpv: [],
                listPromociones: ["-"], // Pongo '-' para cuando cargue la vista no se vea el rojo de no hay elementos
                idBusiness: this.$route.params.idBusiness,
                idTpv: this.$route.params.idTpv,
                respuesta: true,

                codigo: "",
                active: true,
                cantidadDescuento: 0,
                tipoDescuento: 0,
                listTipoDescuento: [
                    {
                        code: 0,
                        name: "Importe"
                    },
                    {
                        code: 1,
                        name: "Porcentaje",
                    },
                ],

                idPromocion: null,
                restriccionCheerfy: false,
            }
        },
        methods: {
            cambioTipoDescuento() {
                this.cantidadDescuento = Math.floor(this.cantidadDescuento);
            },
            getBusiness() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                    .then(function (response) {

                        if (!vm.idBusiness) {
                            vm.idBusiness = response.data.result[0].id;
                        }

                        vm.listBusinesses = response.data.result;
                        vm.getTpv();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getRestriccionCheerfy() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };

                let vm = this;
                this.axios
                .get(
                    this.$store.getters.apiUrl + "general/getRestrictionsByUser",
                    config
                )
                .then(function (response) {
                    if (response.data.response) {
                        for (let i = 0; i < response.data.result.length; i++) {
                        
                            switch (response.data.result[i].idRestriction) {
                            case "75":
                                vm.restriccionCheerfy = true;
                                break;
                            }
                        }
                    }
                }).catch(function(error) {
                    console.log(error);
                });
            },
            cambioNegocio() {
                this.getRestriccionCheerfy();
                this.getTpv();
            },
            getTpv() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt,
                        idBusiness: this.idBusiness
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
                    .then(function (response) {

                        vm.idTpv = response.data.result[0].id;

                        vm.listTpv = response.data.result;

                        vm.getPromociones();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            cambioTpv() {
                this.getPromociones();
            },
            getPromociones() {
                const controller = 'getPromociones';

                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        idTpv: this.idTpv,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                this.$store.dispatch("setIdBusiness", this.idBusiness);

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "promociones/" + controller, config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.listPromociones = response.data.result;
                            vm.respuesta = true;

                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });

                            vm.respuesta = false;
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getPromocion(id) {
                this.idPromocion = id;

                const controller = 'getPromocionById';
                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        idTpv: this.idTpv,
                        idPromocion: id,
                        jwt: this.$store.getters.jwt,
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                this.$store.dispatch("setIdBusiness", this.idBusiness);

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "promociones/" + controller, config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.codigo = response.data.result.codigo;
                            vm.active = response.data.result.active;
                            vm.tipoDescuento = parseInt(response.data.result.tipoDescuento);
                            vm.cantidadDescuento = response.data.result.descuento;

                            vm.openModal();

                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });

                            vm.respuesta = false;
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            deletePromocion(id) {
                var params = {
                    idBusiness: this.idBusiness,
                    idTpv: this.idTpv,
                    id: id,
                    jwt: this.$store.getters.jwt,
                };

                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                let controller = "deletePromocion";
                this.axios.post(this.$store.getters.apiUrl + 'promociones/' + controller, params, config)
                    .then(function (response) {

                        if (response.data.response) {
                            vm.$notify({
                                message: vm.$t('promocion') + ' ' + vm.$t('eliminado') + ' ' + vm.$t('correctamente'),
                                icon: 'nc-icon nc-check-2',
                                timeout: 2000,
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'success'
                            });

                            vm.getPromociones();

                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    }).catch(function (error) {
                    console.log(error);
                    vm.inProgress = false;
                });

            },
            savePromocion() {
                if (this.codigo === '') {
                    swal({
                        title: this.$t('atencion'),
                        text: this.$t('elCampoCodigoEsRequerido'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                } else {
                    var config = {
                        params: {
                            jwt: this.$store.getters.jwt
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };
                    var params = {
                        idBusiness: this.idBusiness,
                        idTpv: this.idTpv,
                        codigo: this.codigo,
                        tipoDescuento: this.tipoDescuento,
                        cantidadDescuento: this.cantidadDescuento,
                        active: this.active,
                        idPromocion: this.idPromocion,
                        jwt: this.$store.getters.jwt
                    };

                    let vm = this;
                    let controller = this.idPromocion ? "editPromocion" : "newPromocion";

                    this.axios.post(this.$store.getters.apiUrl + 'promociones/' + controller, params, config)
                        .then(function (response) {
                            if (response.data.response) {
                                let notify = vm.idPromocion ? vm.$t("actualizada") : vm.$t("creada");

                                vm.$notify({
                                    message: vm.$t('promocion') + ' ' + notify + ' '+ vm.$t('correctamente'),
                                    icon: 'nc-icon nc-check-2',
                                    timeout: 2000,
                                    horizontalAlign: 'right',
                                    verticalAlign: 'top',
                                    type: 'success'
                                });

                                vm.getPromociones();

                                vm.$modal.hide("modal-nueva-promocion");

                                vm.idPromocion = null;
                                vm.codigo = "";
                                vm.active = true;
                                vm.tipoDescuento = 0;
                                vm.cantidadDescuento = 0;

                            } else {
                                swal({
                                    title: vm.$t('atencion'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });
                            }
                        }).catch(function (error) {
                            console.log(error);
                            vm.inProgress = false;
                        });
                }
            },

            closeModal() {
                this.$modal.hide("modal-nueva-promocion");
                this.idPromocion = null;
                this.codigo = "";
                this.active = true;
                this.tipoDescuento = 0;
                this.cantidadDescuento = 0;
            },

            openModal() {
                this.$modal.show("modal-nueva-promocion");
            },

            modalBorrarPromocion(id) {
                swal({
                    title: this.$t('deseaEliminarEstaPromocion'),
                    text: this.$t('estaOperacionNoSePuedeDeshacer'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-danger btn-fill',
                    confirmButtonText: this.$t('siBorrarEstaPromocion'),
                    cancelButtonText: this.$t('cancelar'),
                    buttonsStyling: true
                }).then((result) => {
                    if (result.value) {
                        this.deletePromocion(id);
                    }
                });
            },

            changeActivo(id, activo) {
                var config = {
                    params: {
                    jwt: this.$store.getters.jwt,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };
                var params = {
                    idBusiness: this.idBusiness,
                    idPromocion: id,
                    activo: activo,
                    jwt: this.$store.getters.jwt,
                };

                let vm = this;
                let controller = "updateActivePromotion";
                this.axios
                    .post(
                        this.$store.getters.apiUrl + "promociones/" + controller,
                        params,
                        config
                    )
                    .then(function(response) {
                        if (response.data.response) {
                            vm.getPromociones();

                            let notify = vm.$t("editado");
                            vm.$notify({
                                message:
                                    vm.$t("promocion") + " " + notify + " " + vm.$t("correctamente"),
                                icon: "nc-icon nc-check-2",
                                timeout: 2000,
                                horizontalAlign: "right",
                                verticalAlign: "top",
                                type: "success",
                            });
                        } else {
                            swal({
                                title: vm.$t("atencion"),
                                text: response.data.message,
                                confirmButtonClass: "btn btn-info btn-fill",
                                type: "error",
                            });
                        }
                    })
                    .catch(function(error) {
                        console.log(error);
                        vm.inProgress = false;
                    });
            }
        },
    }
</script>

<style scoped>
    [v-cloak] {
        display: none;
    }
    tbody tr:hover {
        background-color: rgba(0, 153, 130, 0.2);
    }
    tbody td {
        padding: 0 !important;
    }
    td div {
        padding: 12px 8px;
        color: #333;
    }
    .buttonsSearch:hover {
        cursor: pointer;
        background-color: rgba(0, 153, 130, 0.1);
    }
    .card {
        padding: 20px;
    }
    .input-group button {
        height: 40px;
    }
</style>




// WEBPACK FOOTER //
// src/pages/Dashboard/Integraciones/Cheerfy/Cheerfy.vue